import React, {useEffect, useState} from 'react';
import {FormattedMessage} from "react-intl";
import {Redirect} from "react-router-dom";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import NotificationsActive from "@mui/icons-material/NotificationsActive";

import store from "store";

import Page from "components/page/Page";
import Snackbar from "components/snackbar/snackbar";

import {Authorizations, hasAuthorization} from "utils/authorizations";

import ConfigList from "./components/ConfigList";
import ConfigForm from "./components/ConfigForm";

import {list} from "api/invoiceSequenceConfiguration/list";

function InvoiceNumbering() {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [isErrorDisplayed, setErrorDisplayed] = useState(false);

    const authorizations = store.getState().authentication?.authorizations;
    const isAuthorized = hasAuthorization(authorizations, Authorizations.GLOBAL_ORGANIZATION_MANAGEMENT);

    function refresh() {
        setLoading(true);

        list('order[type]=asc&order[configurationCode]=asc')
            .then((response) => {
                setItems(response ?? []);
            })
            .catch(() => setErrorDisplayed(true))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        if (!isAuthorized) {
            return;
        }

        refresh();
    }, []);

    if (!isAuthorized) {
        return <Redirect to={'/'} />;
    }

    function openEditDialog(item) {
        setSelectedItem(item);
        setDialogOpen(true);
    }

    function closeEditDialog() {
        setDialogOpen(false);
        setSelectedItem(null);
    }

    return (
        <Page
            titleId={'invoiceNumbering.title'}
            subtitleId={'invoiceNumbering.subtitle'}
            fullPage
            loading={loading}
        >
            <ConfigList
                items={items}
                onEdit={openEditDialog}
            />
            <Dialog
                open={isDialogOpen}
                onClose={closeEditDialog}
                maxWidth={'sm'}
                fullWidth
                scroll={'body'}
            >
                <DialogContent>
                    {selectedItem && (
                        <ConfigForm
                            configuration={selectedItem}
                            onCancel={closeEditDialog}
                            onSaved={() => {
                                closeEditDialog();
                                refresh();
                            }}
                            onError={() => setErrorDisplayed(true)}
                        />
                    )}
                </DialogContent>
            </Dialog>
            <Snackbar
                open={isErrorDisplayed}
                close
                closeNotification={() => setErrorDisplayed(false)}
                place={'bl'}
                color={'danger'}
                icon={() => <NotificationsActive />}
                message={<FormattedMessage id={'invoiceNumbering.notification.error'} />}
            />
        </Page>
    );
}

export default InvoiceNumbering;
